import axiosInstance from '../axiosInstance';
import { API_ROUTES } from '../routes';
import { ROUTES } from '../../constants/routes';

export const signUp = async (
	name: string,
	email: string,
	password: string,
	referralCode: string,
	timezone: string,
	consentGiven: boolean,
	marketingEmailsConsentGiven: boolean,
	saveCookiesConsentGiven: boolean
) => {
	try {
		const response = await axiosInstance.post(API_ROUTES.signUp, {
			name,
			email,
			password,
			referralCode,
			timezone,
			consentGiven,
			marketingEmailsConsentGiven,
			saveCookiesConsentGiven,
		});

		const { accessToken, refreshToken } = response.data.data;
		localStorage.setItem('accessToken', accessToken);
		localStorage.setItem('refreshToken', refreshToken);

		return response.data;
	} catch (error) {
		console.error('Error during sign-up:', error);
		throw error;
	}
};

export const sendOTP = async () => {
	try {
		const response = await axiosInstance.post(API_ROUTES.sendOTP);

		return response.data;
	} catch (error) {
		console.error('Error sending OTP:', error);
		throw error;
	}
};

export const resendOTP = async () => {
	try {
		const response = await axiosInstance.post(API_ROUTES.resendOTP);

		return response.data;
	} catch (error) {
		console.error('Error resending OTP:', error);
		throw error;
	}
};

export const verifyEmail = async (otpCode: string) => {
	try {
		const response = await axiosInstance.post(API_ROUTES.verifyEmail, {
			otpCode,
		});

		return response.data;
	} catch (error) {
		console.error('Error verifying email:', error);
		throw error;
	}
};

export const refreshToken = async () => {
	try {
		const refreshToken = localStorage.getItem('refreshToken');

		if (!refreshToken) {
			throw new Error('No refresh token found');
		}

		const response = await axiosInstance.post(API_ROUTES.refresh, {
			refreshToken,
		});

		const { accessToken, refreshToken: newRefreshToken } = response.data.data;

		localStorage.setItem('accessToken', accessToken);
		localStorage.setItem('refreshToken', newRefreshToken);

		return accessToken;
	} catch (error) {
		console.error('Error during token refresh:', error);
		throw error;
	}
};

export const logout = async () => {
	localStorage.removeItem('accessToken');
	localStorage.removeItem('refreshToken');
	window.location.pathname = ROUTES.signup;
};
